import { Glosarry } from './GlossaryList.types';

const sortByTitle = (glossaryA: Glosarry, glossaryB: Glosarry) => {
  const titleA = glossaryA.translations[0].title.toLowerCase();
  const titleB = glossaryB.translations[0].title.toLowerCase();
  if (titleA < titleB) {
    return -1;
  }
  if (titleA > titleB) {
    return 1;
  }
  return 0;
};

export const groupGlossaryByLetters = (glossaryList: Glosarry[]) =>
  glossaryList.sort(sortByTitle).reduce((acc: { [key: string]: Glosarry[] }, current) => {
    const key = current.translations[0].title[0].toUpperCase();
    return {
      ...acc,
      [key]: [...(acc[key] ? acc[key] : []), current],
    };
  }, {});
